import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import OrderProgressStatus from './OrderProgressStatus';
import OrderCanceledStatus from './OrderCanceledStatus';

const OrderStatus = ({ orderStatus }) => {
    const { currentStatusId, canceled, statusPath } = orderStatus;

    const statusClasses = cx('status__container', {
        'status__container--nopadding': orderStatus === -1,
    });

    return (
        <div className="order__del-status">
            <div className={statusClasses}>
                {!canceled ? (
                    <OrderProgressStatus
                        statusPath={statusPath ? Object.entries(statusPath) : null}
                        currentStatusId={currentStatusId || null}
                    />
                ) : (
                    <OrderCanceledStatus />
                )}
            </div>
        </div>
    );
};

OrderStatus.propTypes = {
    orderStatus: PropTypes.object.isRequired,
};

export default OrderStatus;
